import React from 'react';
import { useDispatch } from 'react-redux';
import { createPost, sharePost } from '../../../actions/fileUploadActions';
import Button from '../../../utils/components/Button/Button';
import { useHistory } from "react-router-dom";
import "./Post.css"
const ModalShare = ({ post, displayModal,close }) => {
    const divStyle = {
        display: displayModal ? 'block' : 'none'
    };
    const dispatch = useDispatch()
    const history = useHistory()
    const sharedPost = () => {
        const formData = new FormData();
  
        formData.append("postIdContent",post._id)
        formData.append("typePost",4)

        dispatch(sharePost(formData, close()))
    }
    return (
       
        <div style={divStyle} className='modal'>
            <div className='modal-content minWidthInherit fit-content-width p-5'>
                <div className='column centerContent mb-4 textSecondaryColor'>Desea compartir este post</div>
                <div className='share-btn'>
                    <Button onClick={() => {
                        sharedPost()
                    }} text='Si' />
                    <Button onClick={() => {
                        close()
                    }} text='No' />
                </div>
            </div>
        </div>)
};

export default ModalShare;
